export default {
    listing: {
        pageTitle: 'Campaigns',
        tabs: {
            all: 'All',
            aging: 'Aging',
            archived: 'Archived',
        },
        listingHeaders: {
            name: 'Name',
            createdDate: 'Creation date',
            numberContacts: 'Number of contacts',
            status: 'Status',
            actions: 'Actions',
        },
        status: {
            allSent: 'All sent',
            partiallySent: 'Partially sent',
            errors: 'Errors encoutered',
        },
        actions: {
            archive: 'Archive',
            manage: 'Manage',
        },
        errors: {
            fetching: 'An error occured while fetching the campaigns.',
        },
        noCampaign: 'No campaign',
        wouldYouLikeToAddOne: 'Would you like to add one?',
        createCampaign: 'to create a new campaign.',
    },
    contactListing: {
        pageTitle: 'Campaigns',
        tabs: {
            all: 'All',
            sent: 'Sent',
            unsent: 'Unsent',
            withReply: 'With reply',
            withoutReply: 'Without reply',
        },
        listingHeaders: {
            name: 'Name',
            phone: 'Phone',
            locale: 'Locale',
            sentStatus: 'Sent status',
            reply: 'Reply',
            actions: 'Actions',
        },
        actions: {
            removeFromCampaign: 'Remove from campaign',
            sendMassSms: 'Send mass SMS',
            goToConversation: 'Go to conversation',
        },
        errors: {
            deleting: "An error occured while deleting the campaign's contacts. | An error occured while deleting the campaign's contact.",
            fetching: "An error occured while fetching the campaign's contacts.",
        },
        removeFromCampaignModal: {
            title: 'Remove from campaign',
            message: 'Are you sure you want to remove this contact from the campaign? | Are you sure you want to remove the {number} selected contacts from the campaign?',
        },
        sendCampaign: 'Prepare campaign',
        importContacts: 'Import contacts',
        noContactsInCampaign: 'No contacts',
        toImportContacts: 'to import contacts.',
        toAddContact: 'to add a contact.',
        noMatchingContacts: 'No contacts match the filters',
        wouldYouLikeToAddOne: 'Would you like to add one?',
    },
    campaignModal: {
        addTitle: 'Add campaign',
        editTitle: 'Edit campaign',
        name: 'Name',
        successes: {
            created: 'Campaign created successfully.',
            updated: 'Campaign updated successfully.',
            deleted: 'Campaign deleted successfully. | Campaigns deleted successfully.',
        },
        errors: {
            saving: 'Error saving campaign.',
            deleting: 'Error deleting campaign. | Error deleting campaigns.',
        },
    },
    deleteModal: {
        deleteTitle: 'Delete campaign | Delete campaigns',
        deleteMessage: 'Are you sure you want to delete this campaign? | Are you sure you want to delete the {number} selected campaigns?',
    },
};
